<template>
    <cic-popup
        :title="announcement.name"
        :draggable="false"
        :save-button-label="'Acknowledge'"
        saveable
        class="display_announcement"
        @input="$emit('input', announcement.announcementId)"
        @blur="$emit('blur', announcement.announcementId)"
    >
        <template v-for="word in announcement.message.split(' ')">
            <a
                v-if="word.substring(0, 4) === 'http'"
                :href="[',', '.', '?', '!', ':', ';'].includes(word.slice(-1)) ? word.slice(0, -1) : word"
                style="display: inline"
                target="_blank"
            >
                {{ word }}
            </a>
            <span v-else style="display: inline">
                {{ word }}
            </span>
        </template>
        <template #buttons-before>
            <cic-button id="popup_save" @click="$emit('acknowledge', announcement.announcementId)">
                {{ $t('Acknowledge') }}
            </cic-button>
        </template>
    </cic-popup>
</template>

<script>
    import CicButton from '@/components/CicButton';
    import CicPopup from '@/components/CicPopup';

    export default {
        name: 'DisplayAnnouncement',
        components: {
            CicButton,
            CicPopup,
        },
        props: {
            announcement: {
                type: Object,
                required: true,
            },
        },
        emits: ['acknowledge', 'blur', 'input'],
    };
</script>
